import * as React from 'react';
import { type ReactNode } from 'react';
import styles from './Text.module.css';

type SpanProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>;

export type TextWeight = 'normal' | 'bold' | 'heavy';

export interface Props extends Pick<SpanProps, 'style' | 'className'> {
  children: ReactNode;
  testid?: string;
  weight?: TextWeight;
}

function getWeightClassName(weight: Props['weight']) {
  switch (weight) {
    case 'bold':
      return styles['bold'];
    case 'heavy':
      return styles['heavy'];
    default:
      return styles.normal;
  }
}

/**
 * @deprecated - Please use Paragraph instead
 */
export function Text(props: Props) {
  const { className, testid, weight } = props;
  let spanClassName = getWeightClassName(weight);
  if (className !== undefined) {
    spanClassName = `${spanClassName} ${className}`;
  }

  return (
    <span data-testid={testid} style={props.style} className={spanClassName}>
      {props.children}
    </span>
  );
}
